import { render, staticRenderFns } from "./GJRed.vue?vue&type=template&id=6b224174&scoped=true&"
import script from "./GJRed.vue?vue&type=script&lang=js&"
export * from "./GJRed.vue?vue&type=script&lang=js&"
import style0 from "./GJRed.vue?vue&type=style&index=0&id=6b224174&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b224174",
  null
  
)

export default component.exports